/**
 * Same as find but includes parent element
 */

module.exports = function($) {

  $.fn.swFindWithSelf = function(selector) {
    return this.filter(selector).add(this.find(selector));
  };

};
